import {
  AfterViewInit,
  Component,
  effect,
  input,
  InputSignal,
  Type,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Column, ColumnType } from '../../models/simple-table-model';
import { BehaviorSubject } from 'rxjs';
import {
  CPF_MASK,
  CPF_SIZE,
} from '../../../../constants/cpf-validator.constants';
import { CNPJ_MASK } from '../../../../constants/cnpj-validator.constants';

@Component({
  selector: 'app-table-cell',
  templateUrl: './table-cell.component.html',
  styleUrls: ['./table-cell.component.scss'],
})
export class TableCellComponent implements AfterViewInit {
  readonly ColumnType = ColumnType;
  readonly CPF_MASK = CPF_MASK;
  readonly CNPJ_MASK = CNPJ_MASK;
  readonly CPF_SIZE = CPF_SIZE;

  column: InputSignal<Column> = input<Column>();
  row: InputSignal<Type<unknown>> = input<Type<unknown>>();

  index: InputSignal<number> = input<number>();

  @ViewChild('dynamicComponentContainer', { read: ViewContainerRef })
  dynamicComponentContainerRef: ViewContainerRef;

  viewInitedSubject = new BehaviorSubject(false);

  ngAfterViewInit(): void {
    this.viewInitedSubject.next(true);
  }

  constructor() {
    effect(() => {
      if (!this.column()?.['component']) {
        return;
      }
      this.loadDynamicComponent(this.column().component.component);
    });
  }

  loadDynamicComponent<C>(componentType: Type<C>): void {
    this.viewInitedSubject.asObservable().subscribe((inited) => {
      if (!inited || !this.dynamicComponentContainerRef) {
        return;
      }

      this.dynamicComponentContainerRef.clear();
      const componentRef =
        this.dynamicComponentContainerRef.createComponent(componentType);
      const component = this.column()?.component;
      Object.entries(component?.data ?? {}).forEach(([k, v]) => {
        if (typeof component.data?.['items'] === 'function' && k === 'items') {
          componentRef.setInput(k, component.data?.['items'](this.row()));
          return;
        }
        componentRef.setInput(k, v);
      });
      if (component.formControl && component.formArray?.length) {
        componentRef.setInput(
          'formControlRef',
          component.formArray.controls?.[this.index()]?.get(this.column().id)
        );
      }
      componentRef.changeDetectorRef.detectChanges();
    });
  }

  onBooleanChange(newValue: boolean) {
  this.row()[this.column().id] = newValue;

  // Se quiser chamar API para salvar no backend:
  // this.meuService.updateStatus(this.row().id, newValue).subscribe(...)
}

}
